import React, { createContext, useContext, useEffect, useState } from "react";

const TelegramContext = createContext();

export const TelegramProvider = ({ children }) => {
  const [tg, setTg] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isTelegram, setIsTelegram] = useState(true);

  useEffect(() => {
    if (window.Telegram?.WebApp) {
      const telegram = window.Telegram.WebApp;
      telegram.ready();

      // Підбираємо колір шапки та фону Mini App під body (oklch(21% 0.034 264.665) === #0f172a).
      // На Telegram Desktop після останнього оновлення шапка малюється своїм кольором поверх WebView —
      // без цих викликів на ПК та мобільних з'являється видима межа між шапкою та контентом.
      try {
        if (typeof telegram.setHeaderColor === "function") {
          telegram.setHeaderColor("#0f172a");
        }
      } catch (e) {
        console.warn("setHeaderColor failed:", e);
      }
      try {
        if (typeof telegram.setBackgroundColor === "function") {
          telegram.setBackgroundColor("#0f172a");
        }
      } catch (e) {
        console.warn("setBackgroundColor failed:", e);
      }

      setTg(telegram);
      setIsTelegram(true);

      // Діагностика: виводимо viewport-дані, щоб зрозуміти зсув на десктопі.
      // Після фіксу ці логи можна прибрати.
      try {
        console.log("[TG WebApp]", {
          platform: telegram.platform,
          version: telegram.version,
          colorScheme: telegram.colorScheme,
          viewportWidth: telegram.viewportWidth,
          viewportHeight: telegram.viewportHeight,
          viewportStableHeight: telegram.viewportStableHeight,
          isExpanded: telegram.isExpanded,
          headerColor: telegram.headerColor,
          backgroundColor: telegram.backgroundColor,
        });
      } catch (e) {
        console.warn("[TG WebApp] log failed:", e);
      }

      // Підписуємося на viewport_changed, щоб бачити_changes під час дебагу.
      if (typeof telegram.onEvent === "function") {
        const onViewport = () => {
          console.log("[TG viewportChanged]", {
            viewportHeight: telegram.viewportHeight,
            viewportStableHeight: telegram.viewportStableHeight,
            isExpanded: telegram.isExpanded,
          });
        };
        telegram.onEvent("viewportChanged", onViewport);
      }

      // Відкладаємо expand() до наступного кадру: на повільних клієнтах WebView
      // ще не отримав перший viewport_changed від нативного Telegram,
      // тож негайний expand() може бути проігнорований — звідси "чорний екран".
      requestAnimationFrame(() => {
        if (typeof telegram.expand === "function") {
          try {
            telegram.expand();
          } catch (e) {
            console.warn("expand failed:", e);
          }
        }
      });
    } else {
      setIsTelegram(false);
    }
    setLoading(false);
  }, []);

  if (loading) {
    return <p>Завантаження...</p>;
  }

  if (!isTelegram) {
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <h2>Будь ласка, відкрийте додаток через Telegram</h2>
        <p>Mini-app доступний лише всередині Telegram.</p>
      </div>
    );
  }

  return (
    <TelegramContext.Provider value={tg}>{children}</TelegramContext.Provider>
  );
};

export const useTelegram = () => {
  return useContext(TelegramContext);
};
